jQuery(function ($) {
  // Lookup things that don't change
  const $detailLeft = $('.profile-detail__left');
  const $detailLeftContent = $('.profile-detail__left-content');

  const updatePositionClasses = function () {
    $detailLeftContent.removeClass('profile-detail__left-content--fixed');
    $detailLeftContent.removeClass('profile-detail__left-content--bottom');

    const inLayoutBuilder = $detailLeftContent.parents('.layout-builder__region').length;
    const isMobile = $(window).width() < 900;

    if (inLayoutBuilder || isMobile) {
      $detailLeftContent.css('top', '');
      return;
    }

    const scrollTop = $(window).scrollTop();
    const height = $('.profile-detail').height();
    const mainHeight = $('.profile-detail__main').height();
    const visibleHeight = height - scrollTop;
    const sidebarHeight = $detailLeftContent.height() + 60;

    if (sidebarHeight < mainHeight) {
      if (sidebarHeight >= visibleHeight) {
        // Not enough room. Scroll with content.
        $detailLeftContent.addClass('profile-detail__left-content--bottom');
        $detailLeftContent.css('top', '');
      } else {
        // Fix to top.
        $detailLeftContent.addClass('profile-detail__left-content--fixed');

        const navBottom = $('.top-nav')[0].getBoundingClientRect().bottom;

        // Account for local tasks when logged in.
        const $localTasks = $('.subnav--local-tasks');
        let localTasksBottom = 0;
        if ($localTasks.length) {
          localTasksBottom = $localTasks[0].getBoundingClientRect().bottom;
        }
        $detailLeftContent.css('top', `calc(${Math.max(navBottom, localTasksBottom)}px + 2rem)`);
      }
    }

    // To avoid choppy CSS transition, only add / remove class if needed.
    const hasScrollClass = $detailLeft.hasClass('profile-detail__left--scrolled');
    if (scrollTop > 0) {
      if (!hasScrollClass) {
        $detailLeft.addClass('profile-detail__left--scrolled');
      }
    } else if (hasScrollClass) {
      $detailLeft.removeClass('profile-detail__left--scrolled');
    }
  };

  if ($detailLeft.length) {
    const ro = new ResizeObserver(updatePositionClasses);
    ro.observe($('body')[0]);

    $(window).on('scroll resize', updatePositionClasses);
    updatePositionClasses();
  }
});
